export class CallGroup {
  protected guid!: string;
  protected name!: string;
  protected icon!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(object: any) {
    Object.assign(this, object);
  }

  getGuid(): string {
    return this.guid;
  }

  setGuid(guid: string): void {
    this.guid = guid;
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): void {
    this.name = name;
  }

  getIcon(): string {
    return this.icon;
  }

  setIcon(icon: string): void {
    this.icon = icon;
  }

  toString(): string {
    return `CallGroup{ guid='${this.guid}', name='${this.name}', icon='${this.icon}' }`;
  }

  static getGroupFromJson(object: any): CallGroup {
    let callGroup = new CallGroup(object);
    return callGroup;
  }
}
